export const statusTranspile = {
    0: '回測完成',
    1: '評分完成',
    22: '回測完成',
    12: '評分完畢'
}